import { TRANSFER_DIRECTIONS } from 'services/search';
import { InstructionSource, formatters as commonFormatters, TRANSFER_STATES, TRANSFER_TYPES } from 'common';
import formatters from './formatters';

export const LOCAL_STORAGE_COLUMNS_KEY = 'SEARCH_RESULTS_COLUMNS';
export const MAX_COLUMN_WIDTH = 500;
export const MIN_COLUMN_WIDTH = 50;

export const SEARCH_RESULTS_COLUMNS = {
  id: {
    clickable: false,
    inputType: 'input',
    // Provide a state.prevPath so the details page knows the user was linked from the search page.
    // This allows us to decide what the back button on the details page should do.
    formatter: formatters.id,
    filter: 'text',
    resizable: true,
    sortable: true,
    width: 130,
    isVisible: true,
  },
  method: {
    clickable: false,
    inputType: 'select',
    formatter: commonFormatters.formatTransferType,
    options: formatters.makeOptions(Object.values(TRANSFER_TYPES), commonFormatters.formatTransferType),
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  programName: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  journalType: {
    filter: 'text',
    clickable: false,
    inputType: 'input',
    resizable: true,
    sortable: true,
    width: 140,
    isVisible: false,
  },
  apexAccountNumber: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  date: {
    clickable: false,
    formatter: formatters.createdDate,
    filter: formatters.createdOnFilter,
    inputType: 'input',
    placeholder: 'YYYY/MM/DD HH:MM',
    resizable: true,
    sortable: true,
    width: 130,
    isVisible: true,
  },
  state: {
    clickable: false,
    resizable: true,
    inputType: 'select',
    formatter: commonFormatters.formatTransferState,
    options: formatters.makeOptions(TRANSFER_STATES, commonFormatters.formatTransferState),
    filter: 'exact',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  direction: {
    clickable: false,
    resizable: true,
    sortable: true,
    inputType: 'select',
    formatter: commonFormatters.formatTitleCase,
    options: formatters.makeOptions(Object.values(TRANSFER_DIRECTIONS)),
    filter: 'exact',
    width: 130,
    isVisible: true,
  },
  instructionSource: {
    clickable: false,
    resizable: true,
    inputType: 'select',
    formatter: commonFormatters.formatInstructionSource,
    options: formatters.makeOptions(Object.keys(InstructionSource), (val) => InstructionSource[val]),
    filter: 'exact',
    sortable: true,
    width: 220,
    isVisible: true,
    externalPermissionsRequired: true,
  },
  correspondentCode: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
    externalPermissionsRequired: true,
  },
  amount: {
    clickable: false,
    formatter: commonFormatters.formatDollars,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 100,
    isVisible: true,
  },
  achRelationshipId: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  bankAccountIdentifierValue: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  bankAccountNumber: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  bankAccountType: {
    clickable: false,
    inputType: 'input',
    formatter: commonFormatters.formatTitleCase,
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  // FEECM-16278: remove 'corr deposit' column from grid
  // correspondentDeposit: {
  //   clickable: false,
  //   formatter: commonFormatters.formatDollars,
  //   inputType: 'input',
  //   resizable: true,
  //   filter: 'text',
  //   sortable: true,
  //   width: 130,
  //   isVisible: true,
  // },
  isFullDisbursement: {
    inputType: 'select',
    options: [
      { value: '', label: '' },
      { value: true, label: 'Full' },
      { value: false, label: 'Partial' },
    ],
    filter: 'exact',
    formatter: formatters.formatDisbursement,
    clickable: false,
    resizable: true,
    sortable: true,
    width: 130,
    isVisible: true,
  },
  batchId: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
    externalPermissionsRequired: true,
  },
  sourceCountry: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  destinationCountry: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  destinationAccount: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
  },
  ctsId: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    sortable: true,
    width: 130,
    isVisible: true,
    externalPermissionsRequired: true,
  },
  fedWireReferenceNumber: {
    clickable: false,
    inputType: 'input',
    resizable: true,
    filter: 'text',
    formatter: formatters.idType,
    sortable: true,
    width: 130,
  },
  externalId: {
    filter: 'text',
    clickable: false,
    inputType: 'input',
    resizable: true,
    sortable: true,
    width: 130,
    isVisible: true,
  },
  houseBankAccountNumber: {
    filter: 'text',
    clickable: false,
    inputType: 'input',
    resizable: true,
    sortable: true,
    width: 140,
    isVisible: true,
  },
};



// WEBPACK FOOTER //
// ./src/components/SearchResultsTable/constants.js